import styled from "styled-components";
export const UnitListInnerContainerSearch = styled.div.withConfig({
  displayName: "unit-liststyles__UnitListInnerContainerSearch",
  componentId: "sc-1yz4frc-0"
})(["", ""], {
  paddingBottom: "1rem"
});
